// components
import Modal from '@drivesally/sally-ui/lib/components/Modal/Modal';

// date components
import WorkingHoursIntervalEditor from '../../../date/components/WorkingHoursIntervalEditor/WorkingHoursIntervalEditor';

// date constants
import DAYS_OF_WEEK from '../../../date/constants/daysOfWeek.constant.date';

// propTypes
import PropTypes from 'prop-types';

// react
import React from 'react';

const BranchSupportHoursModal = ({
  onChange,
  onClose,
  onSave,
  refresh,
  saving,
  supportHours,
  title,
  visible,
}) => (
  <Modal
    title={title || 'Support Hours Editor'}
    subtitle={!!title ? 'Support Hours Editor' : ''}
    visible={visible}
    onClose={onClose}
    buttonsRight={[{label: 'Save', loading: saving, onClick: onSave}]}
  >
    {(Content) => (
      <Content padding="none" noBorder>
        {[...DAYS_OF_WEEK].map((day) => (
          <WorkingHoursIntervalEditor
            day={day}
            key={day}
            refresh={refresh}
            workingHours={supportHours[day] || []}
            onChange={onChange(day)}
          />
        ))}
      </Content>
    )}
  </Modal>
);

BranchSupportHoursModal.propTypes = {
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  refresh: PropTypes.any,
  saving: PropTypes.bool,
  supportHours: PropTypes.object,
  title: PropTypes.node,
  visible: PropTypes.bool,
};

export default BranchSupportHoursModal;
